import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ery3s63c1u: FaireBrandEntity = {
  token: "b_ery3s63c1u",
  type: "brand",
  name: "Mono B",
  avatarUrl:
    "https://cdn.faire.com/fastly/930487ecde87682944e35a89f56129275b97255a72204ee6191e62aebee78c12.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/c37e8dfb30c8ee4e0af907eab1fa9602380b220651e447b2c538e9c69621ea0c.png",
  logoUrl:
    "https://cdn.faire.com/fastly/930487ecde87682944e35a89f56129275b97255a72204ee6191e62aebee78c12.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c37e8dfb30c8ee4e0af907eab1fa9602380b220651e447b2c538e9c69621ea0c.png",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 150,
  rating: 4.8,
  reviewCount: 1449,
  isTopShop: true,
  isInsider: true,
  description:
    "Mono B offers a wide, evolving range of on-trend styles and inclusive sizes at the fraction of the price of traditional active and leisurewear – without ever sacrificing comfort or quality. Our creative team designs and creates high-performance activewear, athleisure apparel, loungewear, outerwear, and swimwear that enhances daily life and serves as a powerful tool for confidence and self-discovery.",
  meta: {
    source: "api",
    importedAt: "2026-08-18T16:18:15.388Z",
    importedBy: "entity-db-cli",
  },
};
